'use client'

import React from 'react'
import IconButton from '@mui/material/IconButton'
import ShareIcon from '@mui/icons-material/Share'

interface ShareButtonProps {
  title: string
  text?: string
}

const ShareButton: React.FC<ShareButtonProps> = ({ title, text }) => {
  const handleShare = (event: React.MouseEvent) => {
    event.stopPropagation()

    if (navigator.share) {
      navigator
        .share({
          title,
          text: text || '',
          url: window.location.href,
        })
        .catch((error) => console.error('Error sharing:', error))
    } else {
      navigator.clipboard.writeText(window.location.href).then(() => {
        // Could add a toast notification here
      })
    }
  }

  return (
    <IconButton color="primary" aria-label="Share article" title="Share this article" onClick={handleShare}>
      <ShareIcon />
    </IconButton>
  )
}

export default ShareButton
